import {FC, useEffect, useState} from 'react'
import {
  ColumnInvoices,
  FormatTimestampOptions,
  InvoiceConfig,
  StringVariables,
} from '../../interfaces/Invoices'
import {useIntl} from 'react-intl'
import Select, {SingleValue} from 'react-select'
import Form from 'react-bootstrap/Form'
import {
  currencyCodeOption,
  currencylocales,
  formatOptions,
  timeLocales,
  timeZones,
} from '../../interfaces/Options'
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from '@mui/material'
import {Badge, Col, OverlayTrigger, Popover} from 'react-bootstrap'
import {currencyFormatter, inputNumericFormat} from '../../functions/general'
import {set} from 'date-fns'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import useUser from '../../hooks/User'

const X_DEBUG = false

interface FormatInvoiceProps {
  context: 'add' | 'edit'
  formik: any
  errors: ColumnInvoices[] // sub errors input
  selectColumn: ColumnInvoices[]
  setSelectColumn: React.Dispatch<React.SetStateAction<ColumnInvoices[]>>
  setIsBtnLoading: React.Dispatch<React.SetStateAction<boolean>>
  item: InvoiceConfig
  setItem: React.Dispatch<React.SetStateAction<InvoiceConfig>>
}

export const FormatInvoice: FC<FormatInvoiceProps> = ({
  context,
  formik,
  errors,
  selectColumn,
  setSelectColumn,
  setIsBtnLoading,
  item,
  setItem,
}) => {
  // const user = useUser()
  const [numberField, setNumberField] = useState<{id: string; fillDigit: number | null}[]>([])
  const [timestampField, setTimestampField] = useState<
    {
      id: string
      format: string | null
      timezone: string | null
      locale: string | null
      value: string | null
    }[]
  >([])
  const [currencyField, setCurrencyField] = useState<
    {
      id: string
      locale: string | null
      currency_code: string | null
      type: 'number' | 'string' | null
    }[]
  >([])
  const [disabledInput, setDisabledInput] = useState<{ id: string; disabled: boolean }[] | null>(null)

  const intl = useIntl()

  function debounce<T extends (...args: any[]) => void>(
    func: T,
    delay: number
  ): (...args: Parameters<T>) => void {
    let timer: NodeJS.Timeout
    return (...args: Parameters<T>) => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        func(...args)
        setIsBtnLoading(false)
      }, delay)
    }
  }

  const handleFormOnChangeDebounced = debounce(
    (e: React.ChangeEvent<HTMLInputElement>, col: ColumnInvoices, key: string, index?: number) => {
      setIsBtnLoading(true)
      setSelectColumn((prevColumns) =>
        prevColumns.map((c) =>
          c.id === col.id
            ? {
                ...c,
                format: c.format
                  ? {
                      ...c.format,
                      [key]: e.target.value,
                    }
                  : undefined,
              }
            : c
        )
      )
    },
    500
  )
  
  // --------------------------------- DEBUG ---------------------------------
  // useEffect(() => {
  //   console.log('disabledInput', disabledInput)
  // }, [disabledInput])
  // useEffect(() => {
  //   console.log('timestampField', timestampField)
  // }, [timestampField])
  // useEffect(() => {
  //   console.log('currencyField', currencyField)
  // }, [currencyField])
  // useEffect(() => {
  //   console.log('selectColumn', selectColumn)
  // }, [selectColumn])
  // useEffect(() => {
  //   console.log('errors', errors)
  //   console.log('formik.touched', formik.touched)
  //   console.log('formik.error', formik.error)
  // }, [errors, formik.touched, formik.error])

  return (
    <>
      <div
        className='d-flex flex-column gap-4'
        style={{height: '500px', overflowY: 'auto', overflowX: 'hidden', paddingBottom: '30px'}}
      >
        {selectColumn.map((col: ColumnInvoices, index: number) => (
          <div key={index} className='p-2'>
            {X_DEBUG && <pre>{JSON.stringify(col, null, 2)}</pre>}
            <h1 className='bg-danger'>{col.source}</h1>
            {col.type === 'string' && (
              <div className=''>
                <div className="d-flex flex-row gap-4">
                  <h4>{col.label}</h4>
                  {col.model=='pipeline-multi-product' && col.reference == 'products' &&(
                    <Badge style={{ marginBottom:'0.5rem' }} bg="primary">Multi Products</Badge>
                  )}
                </div>
                <div className="d-flex align-items-center gap-2">
                  <Form.Label className='form-label required' htmlFor={`string-${index}`} >
                    {intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})}
                  </Form.Label>
                  <button type="button" className="bg-transparent border-0 p-0 mb-2" data-bs-toggle="tooltip" data-bs-placement="right" title={intl.formatMessage({id: 'FORM.LABEL.INVOICE_DEFAULT_VALUE'})}>
                    <InfoOutlinedIcon style={{ fontSize: '16px' }} />
                  </button>
                  {/* <OverlayTrigger
                    trigger="click"
                    placement={'top'}
                    overlay={
                      <Popover id={`popover-positioned-top`}>
                        <Popover.Header as="h3">{`Popover top`}</Popover.Header>
                        <Popover.Body>
                          <strong>Holy guacamole!</strong> Check this info.
                        </Popover.Body>
                      </Popover>
                    }
                  >
                    <InfoOutlinedIcon style={{ fontSize: '16px' }} />
                  </OverlayTrigger> */}
                </div>
                <Form.Control
                  id={`string-${col.id}`}
                  type='text'
                  aria-describedby={`string-${col.id}`}
                  {...formik.getFieldProps(col.id)}
                  // name={col.id}
                  // value={col.defaultValue}
                  // onChange={
                  //   (e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)
                  //   // handleFormOnChangeDebounced(e, col, 'defaultValue', index)
                  // }
                />
              </div>
            )}
            {col.type === 'timestamp' && (
              <div>
                <h4>{col.label}</h4>
                <div className='row gap-4'>
                  <div className='col'>
                    <label className='form-label text-dark fs-6 required'>Format</label>
                    <Select
                      options={formatOptions}
                      name={`timestamp_format`}
                      value={
                        col.format && 'format' in col.format
                          ? {value: col.format.format, label: col.format.format}
                          : null
                      }
                      onChange={(
                        newValue: SingleValue<{
                          value: string
                          label: string
                        }>
                      ) => {
                        if (newValue) {
                          setIsBtnLoading(true)
                          setTimestampField((prev) => {
                            const existingItem = prev.find((item) => item.id === col.id)

                            if (existingItem) {
                              return prev.map((item) =>
                                item.id === col.id ? {...item, format: newValue.value} : item
                              )
                            }

                            return [
                              ...prev,
                              {id: col.id, format: newValue.value, timezone: null, locale: null, value: null},
                            ]
                          })
                          handleFormOnChangeDebounced(
                            {
                              target: {value: newValue.value},
                            } as React.ChangeEvent<HTMLInputElement>,
                            col,
                            'format',
                            index
                          )
                        }
                      }}
                    />
                  </div>
                  <div className='col'>
                    <label className='form-label text-dark fs-6 required'>{intl.formatMessage({id: 'FORM.LABEL.FORMAT_TIME_LANGUAGE_LOCATION'})}</label>
                    <Select
                      options={timeLocales}
                      name={`timestamp_locales`}
                      value={
                        col.format && 'locale' in col.format
                          ? {value: col.format.locale, label: col.format.locale}
                          : null
                      }
                      onChange={(
                        newValue: SingleValue<{
                          value: string
                          label: string
                        }>
                      ) => {
                        if (newValue) {
                          setIsBtnLoading(true)
                          setTimestampField((prev) => {
                            const existingItem = prev.find((item) => item.id === col.id)

                            if (existingItem) {
                              return prev.map((item) =>
                                item.id === col.id ? {...item, locale: newValue.value} : item
                              )
                            }

                            return [
                              ...prev,
                              {id: col.id, format: null, timezone: null, locale: newValue.value, value: null},
                            ]
                          })
                          handleFormOnChangeDebounced(
                            {
                              target: {value: newValue.value},
                            } as React.ChangeEvent<HTMLInputElement>,
                            col,
                            'locale',
                            index
                          )
                        }
                      }}
                    />
                  </div>
                </div>
                <div className="row gap-4 mt-4">
                    <div className='col'>
                      <div className='d-flex flex-column'>
                        <label className='form-label text-dark fs-6 required'>
                          {intl.formatMessage({id: 'FORM.LABEL.TIMEZONE'})}{' '}
                          {col.format && 'timezone' in col.format
                              ? timeZones.find((prev)=>prev.value === (col.format! as FormatTimestampOptions).timezone)?.utcString
                              : null
                          }
                        </label>
                        <Select
                          options={timeZones}
                          name={`timestamp_timezone`}
                          value={
                            col.format && 'timezone' in col.format
                              ? {value: col.format.timezone, label: col.format.timezone}
                              : null
                          }
                          onChange={(
                            newValue: SingleValue<{
                              value: string
                              label: string
                            }>
                          ) => {
                            if (newValue) {
                              setIsBtnLoading(true)
                              setTimestampField((prev) => {
                                const existingItem = prev.find((item) => item.id === col.id)

                                if (existingItem) {
                                  return prev.map((item) =>
                                    item.id === col.id ? {...item, timezone: newValue.value} : item
                                  )
                                }

                                return [
                                  ...prev,
                                  {id: col.id, format: null, timezone: newValue.value, locale: null, value: null},
                                ]
                              })
                              handleFormOnChangeDebounced(
                                {
                                  target: {value: newValue.value},
                                } as React.ChangeEvent<HTMLInputElement>,
                                col,
                                'timezone',
                                index
                              )
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className='col'>
                      <div className="d-flex align-items-center gap-2">
                        <Form.Label className='form-label required' htmlFor={`string-${index}`} >
                          {intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})} <b>(UTC+00:00)</b>
                        </Form.Label>
                        <button type="button" className="bg-transparent border-0 p-0 mb-2" data-bs-toggle="tooltip" data-bs-placement="right" title={intl.formatMessage({id: 'FORM.LABEL.INVOICE_DEFAULT_VALUE'})}>
                          <InfoOutlinedIcon style={{ fontSize: '16px' }} />
                        </button>
                      </div>
                      <Form.Control
                        type={(() => {
                          const format =
                            timestampField.find((fd) => fd.id === col.id)?.format ||
                            (col.format && 'format' in col.format)
                              ? (col.format as FormatTimestampOptions).format
                              : null

                          if (!format) return 'text'

                          if (
                            [
                              formatOptions[0].value,
                              formatOptions[1].value,
                              formatOptions[2].value,
                            ].includes(format)
                          ) {
                            return 'date'
                          }
                          if (
                            [
                              formatOptions[3].value,
                              formatOptions[4].value,
                              formatOptions[5].value,
                              formatOptions[6].value,
                            ].includes(format)
                          ) {
                            return 'datetime-local'
                          }
                          // if (format === formatOptions[4].value) {
                          //   return 'time'
                          // }
                          return 'text'
                        })()}
                        step='1'
                        disabled={
                          // !timestampField.some(
                          //   (fd) => fd.id === col.id && fd.format && fd.timezone && fd.locale
                          // )
                          // ||
                          !(
                            col.format &&
                            'format' in col.format &&
                            'timezone' in col.format &&
                            'locale' in col.format
                          )
                        }
                        id={`timestamp-${index}`}
                        aria-describedby={`timestamp-${index}`}
                        name={col.id}
                        // value={formik.values[col.id].replace('Z', '').slice(0, 16)}
                        // value={
                        //   col.format && 'value' in col.format
                        //     ? (col.format.value as string | number | string[] | undefined)
                        //     : undefined}
                        // value={setTimestampDefaultValue(col, formik.values[col.id])}
                        value={(() => {
                          console.log('formik.values[col.id]',formik.values[col.id])
                          const format =
                            timestampField.find((fd) => fd.id === col.id)?.format ||
                            (col.format && 'format' in col.format)
                              ? (col.format as FormatTimestampOptions).format
                              : null
      
                          if (!format) return ''
      
                          if (
                            [
                              formatOptions[0].value,
                              formatOptions[1].value,
                              formatOptions[2].value,
                            ].includes(format)
                          ) {
                            console.log('date', formik.values[col.id])
                            return /^\d{4}-\d{2}-\d{2}T.*$/.test(formik.values[col.id])
                            ? formik.values[col.id].split('T')[0]
                              : formik.values[col.id]
                            }
                          if (
                            [
                              formatOptions[3].value,
                              formatOptions[4].value,
                              formatOptions[5].value,
                              formatOptions[6].value,
                              // formatOptions[7].value,
                            ].includes(format)
                          ) {
                            // console.log('date-time', formik.values[col.id])
                            return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(formik.values[col.id])
                              ? formik.values[col.id].replace('Z', '').slice(0, 16)
                              : formik.values[col.id]
                          }
                          // if (format === formatOptions[4].value) {
                          //   return 'time'
                          // }
                          return formik.values[col.id]
                        })()}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          formik.handleChange(e)
                        }}
                      />
                    </div>
                </div>
              </div>
            )}
            {col.type === 'number' && (
              <div className=''>
                <div className="d-flex flex-row gap-4">
                  <h4>{col.label}</h4>
                  {col.model=='pipeline-multi-product' && col.reference == 'products' &&(
                    <Badge style={{ marginBottom:'0.5rem' }} bg="primary">Multi Products</Badge>
                  )}
                </div>
                <div className='row gap-2'>
                  <div className='col d-flex flex-column'>
                    <label className='form-label text-dark fs-6 required'>{intl.formatMessage({id: 'FORM.LABEL.DIGIT_DISPLAY_LENGTH'})}</label>
                    <Select
                      options={Array.from({length: 20}, (_, i) => ({
                        value: i + 1,
                        label: (i + 1).toString(),
                      }))}
                      name={`number_digit_${col.id}`}
                      value={
                        col.format && 'fillDigit' in col.format
                          ? {value: col.format.fillDigit, label: col.format.fillDigit.toString()}
                          : null
                      }
                      onChange={(
                        newValue: SingleValue<{
                          value: number
                          label: string
                        }>
                      ) => {
                        if (newValue) {
                          setIsBtnLoading(true)
                          setNumberField((prev) => {
                            if (prev?.some((item) => item.id === col.id)) {
                              return [
                                ...prev.filter((item) => item.id !== col.id),
                                {id: col.id, fillDigit: newValue.value},
                              ]
                            }
                            return [...prev, {id: col.id, fillDigit: newValue.value}]
                          })
                          handleFormOnChangeDebounced(
                            {
                              target: {value: newValue.value.toString()},
                            } as React.ChangeEvent<HTMLInputElement>,
                            col,
                            'fillDigit',
                            index
                          )
                        }
                      }}
                    />
                    <Form.Control.Feedback type='invalid' className='d-block'>
                      {errors.map((error) => error.id === col.id && error.errorMessage)}
                    </Form.Control.Feedback>
                  </div>

                  <div className='col'>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Label className='form-label required' htmlFor={`string-${index}`} >
                        {intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})}
                      </Form.Label>
                      <button type="button" className="bg-transparent border-0 p-0 mb-2" data-bs-toggle="tooltip" data-bs-placement="right" title={intl.formatMessage({id: 'FORM.LABEL.INVOICE_DEFAULT_VALUE'})}>
                        <InfoOutlinedIcon style={{ fontSize: '16px' }} />
                      </button>
                    </div>
                    <div className="d-flex gap-4">
                      {/* <p>{formik.values[col.id]}</p>
                      <p>{disabledInput?.find((fd) => fd.id === col.id)?.disabled}</p> */}
                      <Form.Control
                        type='text'
                        disabled={
                          // disabledInput?.find((fd) => fd.id === col.id)?.disabled===true ||
                          // numberField.some((fd) => fd.id === col.id) ||
                          // (col.format && 'fillDigit' in col.format)
                          //   ? false
                          //   : true
                          true
                        }
                        name={col.id}
                        id={`number-${index}`}
                        aria-describedby={`number-${index}`}
                        // value={col.defaultValue}
                        value={formik.values[col.id]}
                        onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                          if (!inputNumericFormat(e)) e.preventDefault()
                        }}
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          const value = e.target.value.replace(/[^0-9]/g, '')

                          formik.setFieldValue(col.id, value)
                        }}
                        {...formik.getFieldProps(col.id)}
                        maxLength={
                          numberField.length > 0 && numberField.some((fd) => fd.id === col.id)
                            ? numberField.find((fd) => fd.id === col.id)?.fillDigit || 60
                            : 60
                        }
                      />
                      {/* <button disabled={
                          numberField.some((fd) => fd.id === col.id) ||
                          (col.format && 'fillDigit' in col.format)
                            ? false
                            : true
                        } 
                        type="button" 
                        className='btn btn-outline-danger' 
                        onClick={() => {
                          setDisabledInput((prevState) =>
                            prevState === null
                              ? [{ id: col.id, disabled: true }]
                              : prevState.map((di) =>
                                  di.id === col.id ? { ...di, disabled: true } : di
                                )
                          )
                          formik.setFieldValue(col.id, 'not_set')
                        }}>
                          {intl.formatMessage({id: 'FORM.LABEL.EMPTY'})}
                      </button> */}
                    </div>
                  </div>
                </div>
              </div>
            )}
            {(col.type === 'currency' || col.type === 'currencyString') && (
              <div className=''>
                <div className="d-flex flex-row gap-4">
                  <h4>{col.label}</h4>
                  {col.model=='pipeline-multi-product' && col.reference == 'products' &&(
                    <Badge style={{ marginBottom:'0.5rem' }} bg="primary">Multi Products</Badge>
                  )}
                </div>
                <div className='row gap-4'>
                  <div className='col d-flex flex-column'>
                    <label className='form-label text-dark fs-6 required'>{intl.formatMessage({id:'FORM.LABEL.FORMAT_VIEW_CURRENCY'})} </label>
                    <Select
                      options={currencylocales.map((item) => ({
                        value: item.value,
                        label: `${item.name} (${item.currencyCode})`,
                      }))}
                      name={`currency_locale`}
                      value={
                        col.format && 'locale' in col.format
                          ? {value: col.format.locale, label: col.format.locale}
                          : null
                      }
                      onChange={(
                        newValue: SingleValue<{
                          value: string
                          label: string
                        }>
                      ) => {
                        if (newValue) {
                          setIsBtnLoading(true)
                          setCurrencyField((prev) => {
                            const existingItem = prev.find((item) => item.id === col.id)

                            if (existingItem) {
                              return prev.map((item) =>
                                item.id === col.id ? {...item, locale: newValue.value} : item
                              )
                            }

                            return [
                              ...prev,
                              {id: col.id, locale: newValue.value, currency_code: null, type: null},
                            ]
                          })
                          handleFormOnChangeDebounced(
                            {
                              target: {value: newValue.value},
                            } as React.ChangeEvent<HTMLInputElement>,
                            col,
                            'locale',
                            index
                          )
                        }
                      }}
                    />
                  </div>
                  <div className='col d-flex flex-column'>
                    <label className='form-label text-dark fs-6 required'>
                      {intl.formatMessage({id: 'FORM.LABEL.CURRENCY_CODE'})}
                    </label>
                    <Select
                      options={currencyCodeOption}
                      name={`currency_code`}
                      value={
                        col.format && 'currency' in col.format
                          ? {value: col.format.currency, label: col.format.currency}
                          : null
                      }
                      onChange={(
                        newValue: SingleValue<{
                          value: string
                          label: string
                        }>
                      ) => {
                        if (newValue) {
                          setCurrencyField((prev) => {
                            const existingItem = prev.find((item) => item.id === col.id)

                            if (existingItem) {
                              return prev.map((item) =>
                                item.id === col.id ? {...item, currency_code: newValue.value} : item
                              )
                            }

                            return [
                              ...prev,
                              {id: col.id, locale: null, currency_code: newValue.value, type: null},
                            ]
                          })
                          handleFormOnChangeDebounced(
                            {
                              target: {value: newValue.value},
                            } as React.ChangeEvent<HTMLInputElement>,
                            col,
                            'currency',
                            index
                          )
                        }
                      }}
                    />
                  </div>
                </div>
                <div className='row gap-4 mt-4'>
                  <div className='col d-flex flex-column'>
                    <label className='form-label text-left required'>{intl.formatMessage({id: 'FORM.LABEL.FORMAT_TYPE_CURRENCY'})}</label>
                    <FormControl>
                      <RadioGroup
                        row
                        aria-labelledby='demo-row-radio-buttons-group-label'
                        name='row-radio-buttons-group'
                        value={
                          col.format && 'currencyType' in col.format
                            ? col.format.currencyType
                            : null
                        }
                      >
                        {[
                          {
                            label: intl.formatMessage({id: 'FORM.LABEL.NUMBER'}),
                            value: 'number',
                          },
                          {
                            label: intl.formatMessage({id: 'FORM.LABEL.ALPHABET'}),
                            value: 'string',
                          },
                        ].map((item, index) => (
                          <FormControlLabel
                            key={'radio-' + index}
                            label={item.label}
                            control={<Radio />}
                            value={item.value}
                            // onClick={() => formik.setFieldValue(col.id, '')}
                            onChange={(e: any) => {
                              setIsBtnLoading(true)
                              setCurrencyField((prev) => {
                                const existingItem = prev.find((item) => item.id === col.id)

                                if (existingItem) {
                                  return prev.map((item) =>
                                    item.id === col.id ? {...item, type: e.target.value} : item
                                  )
                                }

                                return [
                                  ...prev,
                                  {
                                    id: col.id,
                                    locale: null,
                                    currency_code: null,
                                    type: e.target.value,
                                  },
                                ]
                              })

                              handleFormOnChangeDebounced(e, col, 'currencyType', index)
                            }}
                          />
                        ))}
                      </RadioGroup>
                    </FormControl>
                  </div>
                  <div className='col'>
                    <div className="d-flex align-items-center gap-2">
                      <Form.Label className='form-label required' htmlFor={`string-${index}`} >
                        {intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})}
                      </Form.Label>
                      <button type="button" className="bg-transparent border-0 p-0 mb-2" data-bs-toggle="tooltip" data-bs-placement="right" title={intl.formatMessage({id: 'FORM.LABEL.INVOICE_DEFAULT_VALUE'})}>
                        <InfoOutlinedIcon style={{ fontSize: '16px' }} />
                      </button>
                    </div>
                    <Form.Control
                      type='text'
                      name={col.id}
                      id={`currency-${index}`}
                      aria-describedby={`currency-${index}`}
                      value={formik.values[col.id]}
                      disabled={
                        // (context==='add' && !currencyField.some(
                        //   (fd) => fd.id === col.id && fd.locale && fd.currency_code && fd.type
                        // ))
                        // ||
                        // !(
                        //   col.format &&
                        //   'locale' in col.format &&
                        //   'currency' in col.format &&
                        //   'currencyType' in col.format
                        // )
                        true
                      }
                      onKeyDown={(e: React.KeyboardEvent<HTMLInputElement>) => {
                        // if (currencyField.some((fd) => fd.id === col.id && fd.type !== 'number'))
                        //   return
                        if (!inputNumericFormat(e)) e.preventDefault()
                      }}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setIsBtnLoading(true)
                        handleFormOnChangeDebounced(e, col, 'defaultValue', index)
                        if (currencyField.some((fd) => fd.id === col.id && (fd.type === 'number' || fd.type === 'string'))) {
                          const value = e.target.value.replace(/[^0-9]/g, '')

                          formik.setFieldValue(col.id, (value))
                          // formik.setFieldValue(col.id, currencyFormatter(value, col.format && 'currencyType' in col.format && col.format.currencyType === 'IDR' ? true : false))
                        }
                        formik.setFieldValue(col.id, e.target.value)
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            {/* TODO: (UNUSED) */}
            {col.type === 'array' && (
              <div className=''>
                <div className="d-flex flex-row gap-4">
                  <h4>{col.label}</h4>
                  {col.model=='pipeline-multi-product' && col.reference == 'products' &&(
                    <Badge style={{ marginBottom:'0.5rem' }} bg="primary">Multi Products</Badge>
                  )}
                  {(col.model=='pipeline-multi-product' || col.model=='pipeline-cf') && col.reference == 'customFields' &&(
                    <Badge bg="primary">Multi CustomField</Badge>
                  )}
                </div>
                <div className="d-flex align-items-center gap-2">
                  <Form.Label className='form-label required' htmlFor={`string-${index}`} >
                    {intl.formatMessage({id: 'FORM.LABEL.DEFAULT_VALUE'})}
                  </Form.Label>
                  <button type="button" className="bg-transparent border-0 p-0 mb-2" data-bs-toggle="tooltip" data-bs-placement="right" title={intl.formatMessage({id: 'FORM.LABEL.INVOICE_DEFAULT_VALUE'})}>
                    <InfoOutlinedIcon style={{ fontSize: '16px' }} />
                  </button>
                </div>
                <Form.Control
                  id={`string-${col.id}`}
                  type='text'
                  aria-describedby={`string-${col.id}`}
                  {...formik.getFieldProps(col.id)}
                  // name={col.id}
                  // value={col.defaultValue}
                  // onChange={
                  //   (e: React.ChangeEvent<HTMLInputElement>) => formik.handleChange(e)
                  //   // handleFormOnChangeDebounced(e, col, 'defaultValue', index)
                  // }
                />
              </div>
            )}
            {formik.touched[col.id] && formik.errors[col.id] && (
              <Form.Control.Feedback type='invalid' className='d-block'>
                {formik.errors[col.id]}
              </Form.Control.Feedback>
            )}
            <div className='mt-4 separator separator-dashed' />
          </div>
        ))}
      </div>
    </>
  )
}
